export default function getRegistrySchemasTitle(): string {
  return 'Entity schemas';
}
